import React from 'react';
import { Card } from '../components/ui/Card';
import { SearchIcon, PlusIcon, FilterIcon, DownloadIcon, DollarSignIcon, CheckCircleIcon, AlertCircleIcon } from 'lucide-react';
export const FeeManagement = () => {
  return <div className="space-y-6" data-id="element-700">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between" data-id="element-701">
        <div data-id="element-702">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-703">Fee Management</h1>
          <p className="mt-1 text-sm text-gray-500" data-id="element-704">
            Manage student fees, payments, and receipts
          </p>
        </div>
        <div className="mt-4 sm:mt-0" data-id="element-705">
          <button className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 flex items-center" data-id="element-706">
            <PlusIcon size={18} className="mr-1" data-id="element-707" />
            <span data-id="element-708">Record Payment</span>
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-709">
        <Card className="bg-gradient-to-r from-green-50 to-green-100 border border-green-200" data-id="element-710">
          <div className="flex items-center" data-id="element-711">
            <div className="p-3 rounded-full bg-green-500 bg-opacity-10" data-id="element-712">
              <DollarSignIcon size={24} className="text-green-600" data-id="element-713" />
            </div>
            <div className="ml-4" data-id="element-714">
              <p className="text-sm font-medium text-green-600" data-id="element-715">
                Total Collected (Current Month)
              </p>
              <p className="text-2xl font-bold text-green-700" data-id="element-716">₹12,45,000</p>
            </div>
          </div>
        </Card>
        <Card className="bg-gradient-to-r from-blue-50 to-blue-100 border border-blue-200" data-id="element-717">
          <div className="flex items-center" data-id="element-718">
            <div className="p-3 rounded-full bg-blue-500 bg-opacity-10" data-id="element-719">
              <CheckCircleIcon size={24} className="text-blue-600" data-id="element-720" />
            </div>
            <div className="ml-4" data-id="element-721">
              <p className="text-sm font-medium text-blue-600" data-id="element-722">
                Payments Processed Today
              </p>
              <p className="text-2xl font-bold text-blue-700" data-id="element-723">42</p>
            </div>
          </div>
        </Card>
        <Card className="bg-gradient-to-r from-red-50 to-red-100 border border-red-200" data-id="element-724">
          <div className="flex items-center" data-id="element-725">
            <div className="p-3 rounded-full bg-red-500 bg-opacity-10" data-id="element-726">
              <AlertCircleIcon size={24} className="text-red-600" data-id="element-727" />
            </div>
            <div className="ml-4" data-id="element-728">
              <p className="text-sm font-medium text-red-600" data-id="element-729">
                Pending Payments
              </p>
              <p className="text-2xl font-bold text-red-700" data-id="element-730">128</p>
            </div>
          </div>
        </Card>
      </div>
      <Card data-id="element-731">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between pb-4 border-b border-gray-200" data-id="element-732">
          <div className="relative" data-id="element-733">
            <span className="absolute inset-y-0 left-0 flex items-center pl-3" data-id="element-734">
              <SearchIcon size={18} className="text-gray-400" data-id="element-735" />
            </span>
            <input type="text" placeholder="Search by student name or ID..." className="pl-10 pr-4 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 w-full sm:w-64" data-id="element-736" />
          </div>
          <div className="mt-3 sm:mt-0 flex space-x-2" data-id="element-737">
            <button className="px-3 py-2 border border-gray-300 rounded-md text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 flex items-center" data-id="element-738">
              <FilterIcon size={16} className="mr-1" data-id="element-739" />
              <span data-id="element-740">Filters</span>
            </button>
            <button className="px-3 py-2 border border-gray-300 rounded-md text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 flex items-center" data-id="element-741">
              <DownloadIcon size={16} className="mr-1" data-id="element-742" />
              <span data-id="element-743">Export</span>
            </button>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-744">
          <table className="min-w-full divide-y divide-gray-200 mt-4" data-id="element-745">
            <thead className="bg-gray-50" data-id="element-746">
              <tr data-id="element-747">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-748">
                  Student
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-749">
                  Receipt #
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-750">
                  Amount
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-751">
                  Date
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-752">
                  Payment Mode
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-753">
                  Status
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-754">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-755">
              {[{
              name: 'Rahul Sharma',
              id: 'ST2023001',
              receipt: 'RCP23456',
              amount: '₹45,000',
              date: 'Aug 12, 2023',
              mode: 'Online Transfer',
              status: 'Successful'
            }, {
              name: 'Priya Patel',
              id: 'ST2023014',
              receipt: 'RCP23455',
              amount: '₹32,500',
              date: 'Aug 11, 2023',
              mode: 'Credit Card',
              status: 'Successful'
            }, {
              name: 'Amit Kumar',
              id: 'ST2023022',
              receipt: 'RCP23454',
              amount: '₹28,000',
              date: 'Aug 10, 2023',
              mode: 'Debit Card',
              status: 'Successful'
            }, {
              name: 'Neha Singh',
              id: 'ST2023035',
              receipt: 'RCP23453',
              amount: '₹45,000',
              date: 'Aug 09, 2023',
              mode: 'Online Transfer',
              status: 'Successful'
            }, {
              name: 'Vikram Joshi',
              id: 'ST2023041',
              receipt: 'RCP23452',
              amount: '₹18,500',
              date: 'Aug 08, 2023',
              mode: 'Cash',
              status: 'Successful'
            }, {
              name: 'Anjali Desai',
              id: 'ST2023048',
              receipt: 'RCP23451',
              amount: '₹32,500',
              date: 'Aug 07, 2023',
              mode: 'Online Transfer',
              status: 'Failed'
            }, {
              name: 'Rajesh Khanna',
              id: 'ST2023052',
              receipt: 'RCP23450',
              amount: '₹45,000',
              date: 'Aug 06, 2023',
              mode: 'Credit Card',
              status: 'Successful'
            }].map((payment, index) => <tr key={index} data-id="element-756">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-757">
                    <div className="flex items-center" data-id="element-758">
                      <div className="flex-shrink-0 h-8 w-8 bg-indigo-100 rounded-full flex items-center justify-center" data-id="element-759">
                        <span className="text-xs font-medium text-indigo-800" data-id="element-760">
                          {payment.name.split(' ').map(n => n[0]).join('')}
                        </span>
                      </div>
                      <div className="ml-4" data-id="element-761">
                        <div className="text-sm font-medium text-gray-900" data-id="element-762">
                          {payment.name}
                        </div>
                        <div className="text-xs text-gray-500" data-id="element-763">
                          {payment.id}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-764">
                    {payment.receipt}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-765">
                    {payment.amount}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-766">
                    {payment.date}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-767">
                    {payment.mode}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-768">
                    <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${payment.status === 'Successful' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`} data-id="element-769">
                      {payment.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-770">
                    <a href="#" className="text-indigo-600 hover:text-indigo-900 mr-3" data-id="element-771">
                      View
                    </a>
                    <a href="#" className="text-indigo-600 hover:text-indigo-900" data-id="element-772">
                      Receipt
                    </a>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="flex items-center justify-between border-t border-gray-200 px-4 py-3 sm:px-6 mt-4" data-id="element-773">
          <div className="flex flex-1 justify-between sm:hidden" data-id="element-774">
            <a href="#" className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-775">
              Previous
            </a>
            <a href="#" className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-776">
              Next
            </a>
          </div>
          <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between" data-id="element-777">
            <div data-id="element-778">
              <p className="text-sm text-gray-700" data-id="element-779">
                Showing <span className="font-medium" data-id="element-780">1</span> to{' '}
                <span className="font-medium" data-id="element-781">7</span> of{' '}
                <span className="font-medium" data-id="element-782">120</span> results
              </p>
            </div>
            <div data-id="element-783">
              <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination" data-id="element-784">
                <a href="#" className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-785">
                  <span className="sr-only" data-id="element-786">Previous</span>
                  <span data-id="element-787">«</span>
                </a>
                <a href="#" aria-current="page" className="z-10 bg-indigo-50 border-indigo-500 text-indigo-600 relative inline-flex items-center px-4 py-2 border text-sm font-medium" data-id="element-788">
                  1
                </a>
                <a href="#" className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium" data-id="element-789">
                  2
                </a>
                <a href="#" className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium" data-id="element-790">
                  3
                </a>
                <span className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700" data-id="element-791">
                  ...
                </span>
                <a href="#" className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium" data-id="element-792">
                  17
                </a>
                <a href="#" className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-793">
                  <span className="sr-only" data-id="element-794">Next</span>
                  <span data-id="element-795">»</span>
                </a>
              </nav>
            </div>
          </div>
        </div>
      </Card>
    </div>;
};